@if (reward) {
  <div class="preview-title">Customer app preview</div>
  <div class="preview-scroll">
    <section class="preview-section">
      <div class="section-label">Explore panel</div>
      <div class="snack-card-slide" [ngStyle]="getSnackCardStyles()">
        <div class="snack-card-inner" [ngStyle]="getSnackCardInnerStyles()">
          <div class="snack-card-title">{{ getBannerTitle() }}</div>
          @if (reward.bannerSubtitleHtml) {
            <div
              class="snack-card-subtitle"
              [innerHTML]="getBannerSubtitleHtml()">
            </div>
          }
          @for (title of reward.bannerButtonTitles || []; track title) {
            <button
              mat-raised-button
              type="button"
              class="snack-card-button"
              >
              {{ title }}
            </button>
          }
        </div>
      </div>
    </section>
    <section class="preview-section">
      <div class="section-label">Reward detail</div>
      <div class="detail-shell">
        <div class="detail-topbar">
          <mat-icon>arrow_back</mat-icon>
          <span>Reward Detail</span>
        </div>
        <div class="detail-content" [ngStyle]="{ color: reward.textColor || '#000000' }">
          @if (reward.detailHeaderHtml) {
            <div
              class="detail-header-html"
              [innerHTML]="getDetailHeaderHtml()">
            </div>
          }
          @if (reward.detailContentsHtml) {
            <div
              class="detail-body-html"
              [innerHTML]="getDetailContentsHtml()">
            </div>
          }
          @if (!hasDetailPreview()) {
            <div class="empty-preview">
              No reward detail content is configured.
            </div>
          }
        </div>
        @if (reward.detailButtonTitles?.length) {
          <div class="detail-actions">
            @for (title of reward.detailButtonTitles || []; track title) {
              <button mat-raised-button type="button">
                {{ title }}
              </button>
            }
          </div>
        }
      </div>
    </section>
  </div>
} @else {
  <div class="empty-preview">No snack preview selected.</div>
}
